import { lightColorPalette } from '@linearb/linui-common';
import { alpha } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
`;

export const ListContainer = styled.div`
  border: 1px solid ${alpha(lightColorPalette.lbBlue_100, 0.6)};
  border-radius: 4px;
  padding: 1px;
`;

export const StyledOption = styled.div`
  font-size: 1.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;

  > span {
    margin-left: 1rem;
  }

  &:hover {
    background-color: ${({ selected }) =>
      selected
        ? alpha(lightColorPalette.lbBlue_100, 0.3)
        : lightColorPalette.lbBlue_5};
  }

  ${({ selected }) =>
    selected &&
    `
  background-color: ${alpha(lightColorPalette.lbBlue_100, 0.2)};
  `}
`;
